import { Box, Typography, Link } from '@mui/material'
import { useCurrentUser } from '~/common/use-current-user'
import { version } from '~/version'

export const VersionFooter = ({ fadeSx }) => {
  const { currentUser } = useCurrentUser()

  if (currentUser?.permissions !== 1) return null

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'absolute',
        bottom: 5,
        left: 0,
        right: 0,
        ...fadeSx,
      }}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{
          display: 'flex',
          gap: 0.75,
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          lineHeight: 1.2,
        }}
      >
        <Link href={version.branchUrl}>{version.branchName}</Link>
        <Link href={version.commitUrl}>{version.commitHash}</Link>
        <em>{version.commitDate}</em>
      </Typography>
    </Box>
  )
}
